/**
 * Frontend-Konstanten rund um Token-Routing, Termin-Anzeige und Cutoff-Logik
 * (DEV-014/AFO-008). Werte sind im AFO-008-Refinement (2026-05-14) festgelegt.
 */

/**
 * Sekunden-zu-Millisekunden-Faktor. `timeSlotSecondsFromEpoch` aus dem Token
 * (AFO-002) kodiert UTC-Sekunden seit `TIMESLOT_EPOCH_UNIX`; die UI rechnet
 * intern in Millisekunden, da `Date` so denkt.
 */
export const TIMESLOT_TO_MS_FACTOR = 1000;

/**
 * Praxis-Zeitzone für die DACH-Pilotphase. Eine zentrale Konstante schützt
 * davor, die TZ inline an verschiedenen Stellen abzulegen — die spätere
 * Multi-Tenant-TZ (Phase 2) hängt sich dann hier an.
 */
export const APPOINTMENT_TZ = 'Europe/Berlin';

/**
 * Sperrfrist für die Selbst-Absage (AFO-008 / N-12). Termine, die näher als
 * `CANCEL_CUTOFF_MS` liegen, schalten den Start-Screen aus und führen direkt
 * zu `BUSINESS_ERROR` mit `TOO_LATE`.
 *
 * 5 Minuten ist die bewusst gesetzte Business-Entscheidung (Release 72.0,
 * N-12): maximal kulant für Patient:innen — nur unmittelbar bevorstehende
 * oder vergangene Termine werden abgewiesen. Der Wert MUSS mit der
 * autoritativen Prüfung der Praxis-Komponente übereinstimmen (cloud-connect,
 * Env `CANCEL_CUTOFF_MS` — dort ebenfalls auf 5 Minuten setzen, der dortige
 * Default ist 24 h!). Der `TOO_LATE`-Text ist bewusst frist-neutral
 * formuliert, damit er bei jeder Fristlänge wahr bleibt.
 *
 * Spec-Einordnung (AFO-008): bewusst Client-side. Client-Clock-Manipulation
 * ist akzeptiert; autoritative Prüfung passiert in der Praxis-Komponente.
 */
export const CANCEL_CUTOFF_MS = 5 * 60 * 1000;

/**
 * Untere Grenze für die Geburtsdatum-Validierung im ISO-Format (YYYY-MM-DD).
 * Liegt deutlich vor der ältesten plausiblen Geburtszeit; Werte davor sind
 * praktisch sicher Tippfehler.
 */
export const DOB_MIN_DATE = '1900-01-01';
